// extracted by mini-css-extract-plugin
export default {"barChart":"bar-chart_barChart__It-mK","chart":"bar-chart_chart__Q87hu","legendIcon":"bar-chart_legendIcon__Konqn","activeLegend":"bar-chart_activeLegend__bRw7D"};